import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Responsive, WidthProvider } from 'react-grid-layout'
import moment from 'moment';
import ReactMarkdown from 'react-markdown'
import { updateDashboard, updateDashboardStatus } from '../../actions/grid'
import ApiService from '../../actions/apiService';
import { getPromotionalContents } from '../../actions/posts'
import { StyledContent } from '../../styles/mixins'
import { StyledGrid, StyledCategoryDiv,StyledSection, StyledCard } from './style'
import ComponentContainer from '../container-component'
import ViewMarkets from '../view-markets'
import CalenderItems from '../view-calendar/calenderItems'
import CalendarModal from "../view-calendar/calendarModal";
import { fetchCategoriesList } from '../../actions/categories'
import { Card, Row, Modal, Button, notification, Checkbox } from 'antd';
import {Link} from 'react-router-dom';
import PositionsView from '../view-positions'
import EarningsTable from '../table-earnings'
import { showDashboardItems } from '../sidebar-permisson'

const ResponsiveGridLayout = WidthProvider(Responsive)
const layouts = {
  lg: [
    {
      w: 24,
      h: 12,
      x: 0,
      y: 0,
      i: 'a',
      minH: 6,
    },
    {
      w: 24,
      h: 12,
      x: 0,
      y: 1,
      i: 'b',
      minH: 6,
    },
    {
      i: 'c',
      x: 0,
      y: 2,
      w: 12,
      h: 6,
      minH: 6
    },
    {
      i: 'd',
      x: 12,
      y: 2,
      w: 12,
      h: 6,
      minH: 6
    },
    {
      i: 'e',
      x: 0,
      y: 3,
      w: 8,
      h: 6,
      minH: 6
    },
    {
      i: 'f',
      x: 8,
      y: 3,
      w: 8,
      h: 6,
      minH: 6
    },
    {
      i: 'g',
      x: 16,
      y: 3,
      w: 8,
      h: 6,
      minH: 6
    },
    {
      i: 'h',
      x: 0,
      y: 4,
      w: 16,
      h: 8,
      minH: 8
    },
    {
      i: 'i',
      x: 0,
      y: 5,
      w: 24,
      h: 7,
      minH: 7
    },
    {
      i: 'j',
      x: 0,
      y: 6,
      w: 24,
      h: 12,
      minH: 12
    },
    {
      i: 'k',
      x: 0,
      y: 7,
      w: 24,
      h: 12,
      minH: 12
    },
  ],
  md: [
    {
      w: 24,
      h: 12,
      x: 0,
      y: 0,
      i: 'a',
      minH: 6,
      moved: false,
      'static': false
    },
    {
      w: 24,
      h: 12,
      x: 0,
      y: 0,
      i: 'b',
      minH: 6,
      moved: false,
      'static': false
    },
    {
      w: 12,
      h: 6,
      x: 0,
      y: 0,
      i: 'c',
      minH: 6,
      moved: false,
      'static': false
    },
    {
      w: 12,
      h: 6,
      x: 12,
      y: 0,
      i: 'd',
      minH: 6,
      moved: false,
      'static': false
    },
    {
      w: 12,
      h: 6,
      x: 0,
      y: 0,
      i: 'e',
      minH: 6,
      moved: false,
      'static': false
    },
    {
      w: 12,
      h: 6,
      x: 12,
      y: 0,
      i: 'f',
      minH: 6,
      moved: false,
      'static': false
    },
    {
      i: 'g',
      x: 0,
      y: 3,
      w: 12,
      h: 6,
      minH: 6
    },
    {
      i: 'h',
      x: 0,
      y: 4,
      w: 16,
      h: 8,
      minH: 8
    },
    {
      i: 'i',
      x: 0,
      y: 5,
      w: 24,
      h: 7,
      minH: 7
    },
    {
      i: 'j',
      x: 0,
      y: 6,
      w: 24,
      h: 12,
      minH: 12
    },
    {
      i: 'k',
      x: 0,
      y: 7,
      w: 24,
      h: 12,
      minH: 12
    },
    
  ],
  sm: [
    {
      i: 'a',
      x: 0,
      y: 0,
      w: 24,
      h: 6,
      minH: 6
    },
    {
      i: 'b',
      x: 0,
      y: 0,
      w: 24,
      h: 6,
      minH: 6
    },
    {
      i: 'c',
      x: 0,
      y: 0,
      w: 24,
      h: 6,
      minH: 6
    },
    {
      i: 'd',
      x: 8,
      y: 0,
      w: 24,
      h: 6,
      minH: 6
    },
    {
      i: 'e',
      x: 16,
      y: 0,
      w: 24,
      h: 6,
      minH: 6
    },
    {
      i: 'f',
      x: 16,
      y: 0,
      w: 24,
      h: 6,
      minH: 6
    },
    {
      i: 'g',
      x: 0,
      y: 0,
      w: 24,
      h: 6,
      minH: 6
    },
  
    {
      i: 'h',
      x: 0,
      y: 4,
      w: 16,
      h: 8,
      minH: 8
    },
    {
      i: 'i',
      x: 0,
      y: 5,
      w: 24,
      h: 7,
      minH: 7
    },
    {
      i: 'j',
      x: 0,
      y: 6,
      w: 24,
      h: 12,
      minH: 12
    },
    {
      i: 'k',
      x: 0,
      y: 7,
      w: 24,
      h: 12,
      minH: 12
    },
    
  ],
  xs: [
    {
      i: 'a',
      x: 0,
      y: 0,
      w: 24,
      h: 6,
      minH: 6
    },
    {
      i: 'b',
      x: 0,
      y: 0,
      w: 24,
      h: 6,
      minH: 6
    },
    {
      i: 'c',
      x: 0,
      y: 0,
      w: 24,
      h: 6,
      minH: 6
    },
    {
      i: 'd',
      x: 8,
      y: 0,
      w: 24,
      h: 6,
      minH: 6
    },
    {
      i: 'e',
      x: 16,
      y: 0,
      w: 24,
      h: 6,
      minH: 6
    },
    {
      i: 'f',
      x: 16,
      y: 0,
      w: 24,
      h: 6,
      minH: 6
    },
    {
      i: 'g',
      x: 0,
      y: 0,
      w: 24,
      h: 6,
      minH: 6
    },
    {
      i: 'h',
      x: 0,
      y: 4,
      w: 16,
      h: 8,
      minH: 8
    },
    {
      i: 'i',
      x: 0,
      y: 5,
      w: 24,
      h: 7,
      minH: 7
    },
    {
      i: 'j',
      x: 0,
      y: 6,
      w: 24,
      h: 12,
      minH: 12
    },
    {
      i: 'k',
      x: 0,
      y: 7,
      w: 24,
      h: 12,
      minH: 12
    },
  ]
}

type Props = {
  isUpdated: boolean,
  layouts: Object,
  onUpdateGrid: Object => void,
  onDashboardStatusChange: (boolean, null | string) => void,
  isFetching: boolean,
  isCategoryFetching: boolean,
  error: null | string
}

type State = {
  layouts: Object,
  isRiskRadarLoading: boolean,
  isRiskRadarEmpty: boolean,
  isVixViewLoading: boolean,
  isVixViewEmpty: boolean,
  isFedFocusLoading: boolean,
  isFedFocusEmpty: boolean,
  promotionData: Array,
}

const displayNone = {
  display: 'none'
}

class NewDashboard extends Component<Props, State> {

  state: State = {
    layouts: layouts,
    isRiskRadarLoading: true,
    isRiskRadarEmpty: true,
    isVixViewLoading: true,
    isVixViewEmpty: true,
    isFedFocusLoading: true,
    isFedFocusEmpty: true,
    promotionData: [],
    isStartUsing: true
  }

  componentDidMount() {

    this.setRiskRadarLoading()
    this.setVixViewLoading()
    this.setFedFocusLoading()
    if(this.props.permissions.trialUser && sessionStorage.getItem("notifyTrailUser") !== "true") {
      this.onNotifyTrailUser()
    }
  }

  componentWillMount() {
    this.getPromotional();
    this.checkCommunication();
    if(!this.props.categories.length) {
      this.props.onFetchCategoriesList()
    }
  }

  onNotifyTrailUser = () => {
    notification.open({
      message: 'You are using a trial version of OptionsEDU.',
      description:
          <a href={'/user-profile/subscription'}> Click here to subscribe.</a>,
      onClick: () => {
        console.log('Notification Clicked!');
      },
      duration: 0
    });
    sessionStorage.setItem("notifyTrailUser", true)
  }
  
  checkCommunication = async () => {
    const userProfile = await ApiService.getProfile();
    const newState = {userProfile: userProfile};
    if (userProfile && userProfile.communicationReview && !userProfile.newUser) {
        const communicationDescription = await ApiService.getCommunicationDescription();
        if (communicationDescription) {
          const args = {
            message: 'Communication Review',
            key: 'communication',
            description: (
              <div><p>{communicationDescription}</p>
                <Button key="submit" type="primary"
                        onClick={async () => {
                          const {userProfile} = this.state;
                          if (userProfile) {
                            userProfile.communicationReview = false;
                            ApiService.postProfile({...userProfile});
                          }
                          notification.close('communication');
                          this.props.history.push('/user-profile/communication');
                        }}>
                  Go to Communication
                </Button></div>
            ),
            duration: 0,
          };
          notification.open(args);
        }
    }
    if (userProfile && userProfile.newUser) {
      const newUserDescription = await ApiService.getNewUserDescription();
      if (newUserDescription) {
        newState.newUserDescription = newUserDescription;
        newState.isNewUserModal = true;
      }
    }
    this.setState({
      ...newState,
    });
  }

  setRiskRadarLoading = () => {

    this.setState({ isRiskRadarLoading: true })

    setTimeout(() => {
      this.setState({
        isRiskRadarLoading: false,
        isRiskRadarEmpty: true
      })
    }, 5000)
  }

  setVixViewLoading = () => {

    this.setState({ isVixViewLoading: true })

    setTimeout(() => {
      this.setState({
        isVixViewLoading: false,
        isVixViewEmpty: true
      })
    }, 5000)
  }

  setFedFocusLoading = () => {

    this.setState({ isFedFocusLoading: true })

    setTimeout(() => {
      this.setState({
        isFedFocusLoading: false,
        isFedFocusEmpty: true
      })
    }, 5000)
  }
  
  getPromotional = async () => {
    try {
      this.setState({
        isPromotionLoading: true
      })
      const promotionData = await getPromotionalContents();
      if (promotionData) {
        if (promotionData && promotionData.data && promotionData.data.data) {
          const roles = (localStorage.getItem('permissions') || '').toLowerCase();
          this.setState({
            isPromotionLoading: false,
            promotionData: promotionData.data.data.promotionalContents.filter(x=> roles.includes((x.roles || '').toLowerCase())),
          });
        } else {
          this.setState({
            isPromotionLoading: false
          })
        }
      } else {
        this.setState({
          isPromotionLoading: false
        })
      }
    } catch(err) {
      this.setState({
        isPromotionLoading: false
      })
    }
    
  }

  getCategories = (categories) => {
    categories.forEach((category) => {
      let posts = (category && category.posts) || [];
      if (posts.length > 1 && category.sortOrder === 'DateDecending') {
        const emptyPosts = posts.filter(a => !a.postDate);
        posts = posts.filter(a => a.postDate).sort((a, b) => {
          if (moment(a.postDate).isAfter(moment(b.postDate))) {
            return -1;
          }
          return 1;
        })
        posts = posts.concat(emptyPosts);
      } else if (posts.length > 1 && category.sortOrder === 'DateAscending') {
        const emptyPosts = posts.filter(a => !a.postDate);
        posts = posts.filter(a => a.postDate).sort((a, b) => {
          if (moment(a.postDate).isBefore(moment(b.postDate))) {
            return -1;
          }
          return 1;
        })
        posts = posts.concat(emptyPosts);
      } else if (posts.length > 1 && category.sortOrder === 'TitleAscending') {
        posts = category.posts.sort((a, b) => {
          if (a.title < b.title) {
            return -1;
          }
          return 1;
        })
      } else if (posts.length > 1 && category.sortOrder === 'TitleDecending') {
        posts = category.posts.sort((a, b) => {
          if (a.title > b.title) {
            return -1;
          }
          return 1;
        })
      }
      category.posts = posts;
    })
    return categories;
  }
  
  startUsing = async () => {
    const {userProfile} = this.state;
    this.setState({
      isNewUserModal: false,
    });
    if (this.state.isStartUsing && userProfile) {
      userProfile.NewUser = false;
      userProfile.newUser = false;
      await ApiService.postProfile({...userProfile});
    }
  }
  
  hideCalendarModal = () => {
    this.setState({
      isCalenderModal: false,
      calenderItem: null,
    })
  }
  
  showCalenderModal = (calenderItem) => {
    this.setState({
      isCalenderModal: true,
      calenderItem,
    })
  }

  render() {

    const { layouts, isPromotionLoading, promotionData, newUserDescription, isNewUserModal, isStartUsing, isCalenderModal, calenderItem  } = this.state
    const { isFetching, error, categories, isCategoryFetching, permissions } = this.props
    let keys = ['c','d','e', 'f', 'g'];
    let promotionKeys = ['a', 'b'];
    const gridStyle = {
      width: '25%',
      textAlign: 'center',
      fontSize: 12,
    };
    return (
      <section>

        { (!!error || isCategoryFetching || isPromotionLoading) ?
          (
            <StyledContent>
              <ComponentContainer
                title={error || 'Loading Dashboard'}
                loading={isFetching}
                empty={!!error}
                resetData={this.setDashboard}>

                <p>Dashboard</p>
              </ComponentContainer>
            </StyledContent>
          ) :
          (
              <StyledGrid>
              <ResponsiveGridLayout
                style={{ width: 'calc(100vw - 220px)' }}
                className='layout'
                layouts={layouts}
                rowHeight={32}
                breakpoints={{ lg: 1260, md: 996, sm: 768, xs: 480 }}
                cols={{ lg: 24, md: 24, sm: 24, xs: 24 }}>
                {
                  promotionData.slice(0,2).map((p, i) => {
                    return <StyledCategoryDiv key={promotionKeys[i]}>
                      <Card title={
                        p.url ? <a target="_blank" href={p.url}><p>{p.name}</p></a> : <p>{p.name}</p>} >
                        {p.description}
                      </Card>
                    </StyledCategoryDiv>
                  })
                }
                {
                  this.getCategories(categories).map((cat, i) => (
                    <StyledCategoryDiv key={keys[i]}>
                      <Card title={<Link
                        to={cat.hassubcategories ? `/category-view/${cat.slug}` : `/categories-post/${cat.slug}`}>{cat.name}</Link>}>
                        <p>{cat.description}</p>
                        {
                          (cat.name === 'Live Sessions') && cat.posts && cat.posts.slice(0,4).map(post => (
                            <Card.Grid className="sub-card" style={gridStyle}>
                              <Link to={`/post/${post.slug}`}>{post.postDate ? moment(post.postDate.substr(0,10)).format('MMM DD, YYYY') : ''}</Link>
                            </Card.Grid>
                          ))
                        }
                        {
                          (cat.name === 'Most Recent Trades' || cat.name === 'Market Overview') && cat.posts && cat.posts.slice(0,4).map(post => (
                            <Card.Grid className="sub-card" style={gridStyle}>
                              <Link to={`/post/${post.slug}`}>{post.title}</Link>
                            </Card.Grid>
                          ))
                        }
                        {
                          (cat.name !== 'Live Sessions' && cat.name !== 'Most Recent Trades') && cat.categories && cat.categories.slice(0,3).map(post => (
                            <Card.Grid className="sub-card" style={{...gridStyle, width: '33.33%',}}>
                              <Link to={`/categories-post/${post.slug}`}>{post.name}</Link>
                            </Card.Grid>
                          ))
                        }
                      </Card>
                    </StyledCategoryDiv>
                  ))
                }

                {
                  showDashboardItems(permissions, "isMarkets") ?
                    <div key="h">
                      <ViewMarkets symbol='Markets'/>
                    </div> : <div style={displayNone}/>
                }

                {
                  showDashboardItems(permissions, "isCalender") ?
                    <div key="i">
                      <CalenderItems showCalenderModal={this.showCalenderModal}/>
                    </div> : <div style={displayNone}/>
                }

                {
                  showDashboardItems(permissions, "isEarnings") ?
                    <div key="j">
                      <StyledSection>
                        <StyledCard
                            bordered={false}
                            title={<Link to={'/earnings'} style={{color: 'inherit'}}>Earnings</Link>}>
                          <div style={{height: '390px', overflowY: 'auto'}}>
                            <Row>
                              <EarningsTable isFromDashBoard/>
                            </Row>
                          </div>
                        </StyledCard>
                      </StyledSection>
                    </div> : <div style={displayNone}/>
                }

                {
                  showDashboardItems(permissions, "isPositions") ?
                    <div key="k">
                      <StyledSection>
                        <StyledCard
                            bordered={false}
                            title={"Positions"}>
                          <div style={{height: '390px', overflowY: 'auto'}}>
                            <Row>
                              <PositionsView defaultOpen/>
                            </Row>
                          </div>
                        </StyledCard>
                      </StyledSection>
                    </div> : <div style={displayNone}/>
                }

              </ResponsiveGridLayout>

            </StyledGrid>
          )
        }
        <Modal
          visible={isNewUserModal}
          title="Welcome"
          closable={false}
          width={800}
          footer={[
            <Checkbox style={{float: 'left'}} key="check" defaultChecked={true} value={isStartUsing} onChange={(e) => this.setState({isStartUsing: e.target.checked})}>Don't show this again</Checkbox>,
            <Button key="submit" type="primary" onClick={this.startUsing}>
              Start Using OptionsEDU
            </Button>
          ]}
        >
          <div><ReactMarkdown escapeHtml={false} source={newUserDescription || ''}/></div>
         
        </Modal>
        {isCalenderModal && <CalendarModal visible={isCalenderModal} item={calenderItem} hideCalendarModal={this.hideCalendarModal}/>}
      </section>
    )
  }
}

const getCategoryList = (permission) => {
  let array = [] // ['Live Sessions','Education','Resources', 'Most Recent Trades', 'Market Overview']
  if(permission.eduUser) {
    array = ["Live Sessions", "Most Recent Trades", "Market Overview"]
  }
  return array
}

const mapStateToProps = (state: Object) => ({
  isUpdated: state.grid.isUpdated,
  layouts: state.grid.layouts,
  isFetching: state.grid.isFetching,
  error: state.grid.error,
  categories: state.categories.categoriesList.filter(x=> getCategoryList(state.user.permissions).includes(x.name)),
  isCategoryFetching: state.categories.isFetching,
  permissions: state.user.permissions
})

const mapDispatchToProps = (dispatch: Function) => ({
  onUpdateGrid(layout: Object) {
    dispatch(updateDashboard(layout))
  },
  onDashboardStatusChange(isFetching: boolean, error: null | string) {
    dispatch(updateDashboardStatus(isFetching, error))
  },
  onFetchCategoriesList: () => {
    fetchCategoriesList(dispatch)
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(NewDashboard)




// WEBPACK FOOTER //
// ./src/components/view-dashboard/new-dashboard.js